import { render } from "./FormatAlignLeft.vue?vue&type=template&id=c18d19ae"
import script from "./FormatAlignLeft.vue?vue&type=script&lang=js"
export * from "./FormatAlignLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatAlignLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c18d19ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c18d19ae', __exports__)) {
    api.reload('c18d19ae', __exports__)
  }
  
  module.hot.accept("./FormatAlignLeft.vue?vue&type=template&id=c18d19ae", () => {
    api.rerender('c18d19ae', render)
  })

}


export default __exports__